import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { stateMap } from '../../../constants/states/all';
import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBreakdown } from '../../../helpers/getBreakdown';

const UL = styled.ul`
  color: #242325;
  margin: 0;
  column-count: 2;
  list-style: none;
  flex: 0 0 72%;
`;

const LI = styled.li`
  display: flex;
  margin: 0 -5px 12px;
  flex-wrap: wrap;
  align-items: center;
  break-inside: avoid;
`;

const Key = styled.span`
  flex: 0 0 40%;
  margin: 0;
  color: var(--bs-text);
  padding: 0px 5px;

  &: last-child {
    font-weight: var(--weight-bold);
    flex: 0 0 60%;
  }
`;

const Value = styled.span`
  flex: 0 0 40%;
  margin: 0;
  color: var(--bs-text);
  padding: 0px 5px;
  font-weight: var(--weight-semibold);
`;

export const Breakdown = () => {

  const [state] = useService(productBuilderMachine);
  const breakdown = getBreakdown(state.context);

  return (
    <UL>
      {breakdown.map(([key, value]): any => {
        return (
          <LI key={key}>
            <Key>{key.includes('measurements') ? `${stateMap[key]} (W) * (H):` : `${stateMap[key]}:`}</Key>
            <Value>{value ? key.includes('measurements') ? `${value}mm` : value : "-"}</Value>
          </LI>
        );
      })}
    </UL>
  );
};
